import React from 'react';
import 'widgets/tiles/components/tile/TileToolbar.scss';

import Tooltip from 'utils/components/Tooltip/Tooltip';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { WidgetMessages } from 'widgets/messages/WidgetMessages';
import classNames from 'classnames';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export interface MyPortfolioCapsulesCapsuleProps {
    symbol: string;
    symbology: SymbologyValues;
    qty: number;
    qtyRemaining: number;
    title: string;
    messages?: StreamMessage[];
    wideTitle?: boolean;
    titleComponent?: React.FC<MyPortfolioCapsuleContentProps>;
}

export function MyPortfolioCapsulesCapsuleHeader(
    props: MyPortfolioCapsulesCapsuleProps
) {
    const {
        symbol,
        symbology,
        qty,
        qtyRemaining,
        messages,
        wideTitle,
        titleComponent,
    } = props;

    const TitleComponent: React.FC<MyPortfolioCapsuleContentProps> =
        titleComponent!;

    const cssClasses = classNames(
        'MyPortfolioCapsulesCapsuleHeader capsule-header panel-header',
        wideTitle && 'wide-title'
    );

    return (
        <div className={cssClasses}>
            <div className="header">
                <div>
                    <Tooltip text={symbol} neverHide={true} className="title">
                        {!titleComponent ? symbol : ''}
                        {titleComponent && (
                            <TitleComponent
                                symbol={symbol}
                                symbology={symbology}
                                qty={qty}
                                qtyRemaining={qtyRemaining}
                            />
                        )}
                    </Tooltip>
                </div>
            </div>
            <div className={'WidgetToolbar toolbar'}>
                <WidgetMessages hideSeparator={true} messages={messages} />
            </div>
        </div>
    );
}
